import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e18c0c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "weeek-statuses-item__block" }

import { GetAttributeOptionsResponseItem } from "@/models";
import {
  TirPmButton,
  TirPmButtonVariantEnum,
  TirPmInput,
} from "tir-components";
import { ArrowPathIcon, TrashIcon } from "tir-style-system/icons/outline";
import { onMounted, PropType, ref } from "vue";

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'weeek-statuses-item',
  props: {
  /**индекс статуса */
  index: { type: Number },
  /**Данные статусов weeek */
  statusesDataWeeek: { type: Array as PropType<GetAttributeOptionsResponseItem[]> },
  /**Статус weeek */
  statusDataWeeek: { type: Object as PropType<GetAttributeOptionsResponseItem> },
},
  setup(__props) {

const props = __props;



/**Удаление статуса */
const removeStatusesWeeek = (index: number) => {
  props.statusesDataWeeek.splice(index, 1);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TirPmInput), {
      class: "weeek-statuses-item__input",
      label: "Статус с weeek.ru",
      isWithHint: false,
      modelValue: __props.statusDataWeeek.WeeekValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.statusDataWeeek.WeeekValue) = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_unref(ArrowPathIcon), { class: "weeek-statuses-item__icon" }),
    _createVNode(_unref(TirPmInput), {
      class: "weeek-statuses-item__input",
      label: "Статус на замену",
      isWithHint: false,
      modelValue: __props.statusDataWeeek.PmValue,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((__props.statusDataWeeek.PmValue) = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_unref(TirPmButton), {
      variant: _unref(TirPmButtonVariantEnum).LinkState,
      onClick: _cache[2] || (_cache[2] = ($event: any) => (removeStatusesWeeek(__props.index)))
    }, {
      leftSlot: _withCtx(() => [
        _createVNode(_unref(TrashIcon), { class: "weeek-statuses-item__icon-trash" })
      ]),
      _: 1
    }, 8, ["variant"])
  ]))
}
}

})